import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { Menu, LogOut, Settings } from "lucide-react";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();

  const navItems = [
    { name: "Accueil", href: "#accueil" },
    { name: "Menu", href: "#menu" },
    { name: "Cave à vins", href: "#vins" },
    { name: "Contact", href: "#contact" },
    { name: "Galerie", href: "#galerie" },
  ];

  const NavLink = ({ href, children, onClick }) => (
    <a
      href={href}
      className="nav-link font-sans text-gray-700 hover:text-primary transition-colors duration-200 cursor-pointer"
      onClick={onClick}
    >
      {children}
    </a>
  );

  const handleLogout = () => {
    logout();
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="#accueil" className="flex items-center">
              <img
                src="/assets/logo.png"
                alt="Au 4A Logo"
                className="h-10 w-auto mr-2"
              />
              <span className="text-2xl font-serif font-bold text-primary">
                Au 4A
              </span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <NavLink key={item.name} href={item.href}>
                {item.name}
              </NavLink>
            ))}

            {/* Admin Section */}
            {isAuthenticated ? (
              <div className="flex items-center space-x-4 ml-4 pl-4 border-l border-gray-200">
                <span className="text-sm text-gray-600">
                  Bonjour, {user?.username}
                </span>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={handleLogout}
                  className="text-gray-600 hover:text-primary"
                >
                  <LogOut className="h-4 w-4 mr-1" />
                  Déconnexion
                </Button>
              </div>
            ) : (
              <a
                href="/admin-login"
                className="text-xs text-gray-400 hover:text-primary transition-colors duration-200 cursor-pointer ml-4"
              >
                <Settings className="h-4 w-4 inline mr-1" />
              </a>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-80 bg-warm-white">
                <div className="flex flex-col space-y-6 mt-8">
                  <div className="text-2xl font-serif font-bold text-primary mb-8">
                    Au 4A
                  </div>
                  {navItems.map((item) => (
                    <NavLink
                      key={item.name}
                      href={item.href}
                      onClick={() => setIsOpen(false)}
                    >
                      <span className="text-lg">{item.name}</span>
                    </NavLink>
                  ))}

                  {/* Mobile Admin Section */}
                  <div className="pt-6 border-t border-gray-200">
                    {isAuthenticated ? (
                      <div className="space-y-4">
                        <div className="text-sm text-gray-600">
                          Connecté en tant que {user?.username}
                        </div>
                        <Button
                          variant="ghost"
                          onClick={handleLogout}
                          className="w-full justify-start text-gray-600 hover:text-primary"
                        >
                          <LogOut className="h-4 w-4 mr-2" />
                          Déconnexion
                        </Button>
                      </div>
                    ) : (
                      <a
                        href="/admin-login"
                        className="flex items-center text-sm text-gray-400 hover:text-primary transition-colors duration-200 cursor-pointer"
                        onClick={() => setIsOpen(false)}
                      >
                        <Settings className="h-4 w-4 mr-2" />
                        Connexion Admin
                      </a>
                    )}
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
